<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="ADMIN.PRODUCTS.ALL.CATEGORIES"
    descriptionKey="ADMIN.IA.PRODUCTS.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="category?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    @if (loading) {
      <app-admin-state-panel mode="loading" titleKey="COMMON.LOADING"></app-admin-state-panel>
    } @else if (hasError || !category) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.PRODUCTS.CATEGORIES.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-category-products
          [payload]="category"
          [showIntro]="false"
          [onUpdate]="reload"
        ></app-form-category-products>
      </app-admin-form-layout>
    }
  </div>
</section>
